import axios from "axios";
import router from '../../../router';

export default {

    async vendors_search(context, payload ){

        const token = context.rootGetters.token;
        console.log('request for vendors');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'vendors_search',
                data: {
                    term: payload.term,
                    limit: payload.limit,
                    offset: payload.offset,
                },
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            return new Promise((resolve, reject) => {
                if(!responseData.data.success){
                    context.commit('setRequestError', {message:responseData.data.message} );
                    reject(responseData.data.message);
                } else {
                    context.commit('setRequestError', {message:''} );
                    context.commit('setVendors', responseData.data.results);
                    resolve(responseData);
                }
            })

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async showrooms_search(context, payload ){

        const token = context.rootGetters.token;
        console.log('request for showrooms');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'showrooms_search',
                data: {
                    term: payload.term,
                    limit: payload.limit,
                    offset: payload.offset,
                },
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            return new Promise((resolve, reject) => {
                if(!responseData.data.success){
                    context.commit('setRequestError', {message:responseData.data.message} );
                    reject(responseData.data.message);
                } else {
                    context.commit('setRequestError', {message:''} );
                    context.commit('setShowrooms', responseData.data.results);
                    resolve(responseData);
                }
            })

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async connections(context){

        const token = context.rootGetters.token;
        console.log('request for connections');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'connections',
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            return new Promise((resolve, reject) => {
                if(!responseData.data.success){
                    context.commit('setRequestError', {message:responseData.data.message} );
                    reject(responseData.data.message);
                } else {
                    context.commit('setRequestError', {message:''} );
                    context.commit('setConnections', responseData.data.results);
                    resolve(responseData);
                }
            })

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    }

}